import { api } from '.';
import {
  IAchievmentPage,
  IMySubscription,
  IPagination,
  IPaymentItem,
  IPromotion,
  IRecommentPaymentItem,
  VendorType,
} from '../model';
import { toQueryString } from '../utils/misc';

export const fetchRecommendPaymentItems = async (vendor: VendorType) => {
  try {
    const { data } = await api.get<IRecommentPaymentItem>(
      `/store/goods-items/recommend${toQueryString({ vendor })}`
    );
    return data;
  } catch (error) {
    return;
  }
};

export const verifyPaymentItem = async (paymentId: string) => {
  const { data } = await api.post(
    `/store/goods-items/${paymentId}/check-purchasable/`
  );

  return data;
};

export type PaymentItemQueries = {
  price_gte?: number; //최소 가격
  prece_lte?: number; //최대가격
  vendor: 'S' | 'A' | 'Z';
};

export const fetchPaymentItems = async (query: PaymentItemQueries) => {
  const { data } = await api.get<IPaymentItem[]>(
    `/store/goods-items/${toQueryString({ ...query })}`
  );
  return data;
};

export const fetchPaymentItemDetail = async (paymentItemId: number) => {
  const { data } = await api.get<IPaymentItem>(
    `/store/goods-items/${paymentItemId}`
  );
  return data;
};

export const fetchPromotion = async (id: number) => {
  const { data } = await api.get<IPromotion>(`/store/promotions/${id}`);

  return data;
};

export const fetchPassItemDetail = async (paymentItemId: number) => {
  const { data } = await api.get<IPaymentItem>(
    `/store/bundle-passes/${paymentItemId}/`
  );
  return data;
};

export const fetchSubscriptionDetail = async (paymentItemId: number) => {
  const { data } = await api.get<IPaymentItem>(
    `/store/subscriptions/${paymentItemId}/`
  );
  return data;
};

export const fetchMySubscriptions = async (page = 1, perPage = 20) => {
  const { data } = await api.get<IPagination<IMySubscription>>(
    `/store/my-subscriptions/${toQueryString({
      page,
      perPage,
    })}`
  );
  return data;
};

export const fetchAchievmentPage = async () => {
  const { data } = await api.get<IAchievmentPage>(`/achievements_page/`);
  return data;
};

export const postAchievement = async ({
  achievementId,
  itemId,
  requirement,
  key,
}: {
  achievementId: number;
  itemId: number;
  requirement?: string | number;
  key?: string;
}) => {
  const requirementKey = key ? key : 'unit_id';
  const { data } = await api.post<IAchievmentPage>(
    `/achievements/${achievementId}/items/${itemId}/purchase/`,
    {
      requirement_completion_extra: {
        [requirementKey]: requirement,
      },
    }
  );
  return data;
};
